import { USER_TYPES } from "store/types";

const initialState = {
  users: [],
  totalCount: 0,
  currentPage: 1,
  loading: false,
  wishlists: [],
  userWishlist: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case USER_TYPES.SET_USERS:
      return {
        ...state,
        users: action.payload.results,
        totalCount: action.payload.count,
        currentPage: action.payload.page,
      };

    case USER_TYPES.SET_WISHLISTS:
      return { ...state, wishlists: action.payload };

    case USER_TYPES.SET_USER_WISHLIST:
      return { ...state, userWishlist: action.payload };

    default:
      return state;
  }
};

export default userReducer;
